// extracted by mini-css-extract-plugin
export default {"popup":"Modal_popup__Fo2by","button":"Modal_button__N0IL2","title":"Modal_title__KzLPP","input":"Modal_input__eFbjF","validationMessage":"Modal_validationMessage__Jj5ox"};